module.exports = __webpack_public_path__ + "editor/icon-add-image-b96e640b2294467fa2c6b6660778f96c.svg";